import cn from 'classnames';
import styles from './BottomDrawer.module.scss';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Backdrop } from '../Backdrop';
import { createPortal } from 'react-dom';

type BottomDrawerProps = {
  className?: string;
  children: ReactNode;
  active: boolean;
  onClose: () => void;
};

export function BottomDrawer({
  active,
  onClose,
  children,
  className,
}: BottomDrawerProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const [body, setBody] = useState<HTMLBodyElement | null>(null);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setBody(document.querySelector('body'));
  }, []);

  if (!body) return;

  return createPortal(
    <>
      <AnimatePresence>
        {active && (
          <motion.div
            className={wrapperClassName}
            initial={{ y: '100%' }}
            animate={{ y: '0%' }}
            exit={{ y: '100%' }}
            transition={{ duration: 0.3, ease: 'linear' }}
            ref={modalRef}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
      <Backdrop onClick={onClose} visible={active} />
    </>,
    body,
  );
}
